// Step 2 of the support-provider profile flow. This is NOT a booking agreement
// and NOT an account — it is a review of the information being submitted so the
// provider can confirm it is correct before it is saved for invoicing.

export interface SupportAgreementDraftDetails {
	supportedPerson: string;
	supportPerson: string;
}

function esc(s: string): string {
	const el = document.createElement('div');
	el.textContent = s;
	return el.innerHTML;
}

export function supportAgreementHtml(_details: SupportAgreementDraftDetails): string {
	return `
    <section class="sp-section sp-agreement" aria-labelledby="sp-review-title">
      <div class="sp-section-kicker">Step 2 of 2</div>
      <h2 id="sp-review-title">Review information to be submitted</h2>
      <p class="sp-section-copy">Check the details you entered above. This creates a support-provider profile used only for invoicing — it is not an account, and you are not agreeing to a booking.</p>

      <div class="sp-terms">
        <section>
          <h3>What happens next</h3>
          <p>Your profile is saved so invoices can be prepared for your supports. When an invoice is created, you receive a link by email to review it and either approve it or send back changes. Nothing is charged or committed here.</p>
        </section>
        <section>
          <h3>How your information is used</h3>
          <p>The details you provide (your name, contact, ABN, and payment details) are used only to prepare and pay invoices for the supports you deliver. They are not shared beyond what is needed for invoicing.</p>
        </section>
      </div>

      <div class="sp-delete-note">
        To request deletion of your submitted profile information, email
        <a href="mailto:accounts@the-hub-ecosystems.com">accounts@the-hub-ecosystems.com</a>.
      </div>

      <div class="sp-checks">
        <label><input type="checkbox" name="information_confirmed" /> I confirm the information I have provided above is correct.</label>
      </div>
    </section>
  `;
}

export function renderSupportAgreement(container: HTMLElement, details: SupportAgreementDraftDetails): void {
	container.innerHTML = supportAgreementHtml(details);
}
